export default __webpack_public_path__ + "static/media/online_shows_1.1d4b8c3a.png";